import React from "react";
import { get } from "lodash";
import "./style.scss";

const Badge = ({ item, thumbnailType, isList = false }) => {
    const dimensions = thumbnailType === "portrait" ? "_3x4" : "_16x9";
    const searchPath = isList ? `badgeImages["${dimensions}"]` : 
    `gist.badgeImages["${dimensions}"]`
    
    const badge = get(item, searchPath);
    if (badge) {
        return (
            <img alt="badge" src={badge} className="badge" role="presentation" />
        );
    }
    return <span/>
}

export default Badge;
